import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  CardTitle,
  CardSubtitle,
  Label,
  Input,
  Container,
  FormFeedback,
  Form,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import * as url from "../../helpers/common_helper";

import toastr from "../../helpers/toastr_helper";
import "toastr/build/toastr.min.css";
import PropTypes from "prop-types";
// import { RoleApi } from "../../apis/RoleApi";
// import { RoleModuleApi } from "../../apis/RoleModuleApi";

import { useHistory } from "react-router-dom";
//Import Breadcrumb
// import Breadcrumbs from "../../components/Common/Breadcrumb";
import Swal from "../../helpers/swal_helper";
import { withTranslation } from "react-i18next";
// import i18n from "../../i18n";
// import constants from "../../config/constants";
import config from "config/config";

// import { CompaniesApi } from "apis/CompaniesApi";
import Breadcrumb from "components/Common/Breadcrumb";
import { SalonApi } from "apis/SalonApi";

const SalonsEdit = (props) => {
  const salon_id = props.match.params.salon_id;
  const [files1, setFiles1] = useState([]);
  const [salon, setSalon] = useState("");
  const [salonstatus, setSalonStatus] = useState("");
  const [documents, setDocuments] = useState([]);

  const fileRegUrl = salon.commercial_reg_image;
  const fileVatUrl = salon.vat_reg_certificate;
  const isRegPDF = fileRegUrl?.toLowerCase().endsWith(".pdf");
  const isVATPDF = fileVatUrl?.toLowerCase().endsWith(".pdf");

  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [modal3, setModal3] = useState(false);
  const [modal4, setModal4] = useState(false);

  const toggleimg1 = () => setModal(!modal);
  const toggleimg2 = () => setModal2(!modal2);
  const toggleimg3 = () => setModal3(!modal3);
  const toggleimg4 = () => setModal4(!modal4);
  const mapUrl =
    salon.latitude && salon.longitude
      ? `https://maps.google.com/maps?q=${salon.latitude},${salon.longitude}&z=15&output=embed`
      : null;
  const [activeData, setActiveData] = useState({
    page: 1,
    totalPage: 1,
    search: "",
    limit: config.LIMIT,
  });

  const getSalonById = () => {
    // console.log(salon_id);
    SalonApi.getSalonById({ salon_id })
      .then((res) => {
        // console.log(res)
        setSalonStatus(res.data.data.status);
        setSalon(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getSalonById();
    // getAllOfferTypes(activeData);
  }, []);

  // Form validation
  const validationType = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name_en: salon.name ?? "",
      address: salon.address ?? "",
      registration_number: salon.registration_number ?? "",
      city: salon.city ?? "",
      // geo_location_link: salon.geo_location_link ?? "",
      image: salon.image ?? "",
      icon: salon.icon ?? "",
      service_at: salon.service_at ?? "",
      price_range: salon.price_range ?? "",
      commercial_reg_image: salon.commercial_reg_image ?? "",
      vat_reg_certificate: salon.vat_reg_certificate ?? "",
      status: salonstatus || "",
      reason: salon.reason ?? "",
      created_by: salon.created_by ?? "",
    },
    validationSchema: Yup.object().shape({
      name_en: Yup.string().required(props.t("Name is required")),

      address: Yup.string().required(props.t("Address is required")),

      status: Yup.string().required(props.t("Status is required")),

      reason: Yup.string().when("status", {
        is: (val) => val === "Amendment_Required" || val === "Rejected",
        then: Yup.string().required(props.t("Reason is required")),
        otherwise: Yup.string().notRequired(),
      }),
    }),
    onSubmit: (values) => {
      const salon = {
        salon_id: salon_id,
        ...values,
      };
      SalonApi.updateSalonStatus(salon)
        .then((res) => {
          if (res.data.message && res.status == 200) {
            // Swal.fire({
            //   text: res.data.message,
            //   icon: "success",
            //   imageAlt: "success image",
            // }).then((result) => {
            //   if (result?.isConfirmed) {
            //     history.push("/salons?status=" + salon?.status);
            //     formClear();
            //     setFiles1();
            //   }
            // });

            history.push("/salons?status=" + salon?.status);
            formClear();
            setFiles1();
          } else {
            toastr.error(res?.data?.message, "");
          }
        })
        .catch(function (error) {
          if (error?.response?.data?.message) {
            toastr.error(error?.response?.data?.message, "");
          } else {
            toastr.error(
              error?.response?.data?.error?.errors?.map(
                (item, v) => `${item.msg}<br>`
              ),
              ""
            );
          }
        });
    },
  });

  const formClear = () => {
    validationType.resetForm();
    setFiles1([]);
  };

  document.title = props.t("Edit Salon") + " | " + props.t("Salon");

  // console.log(salonstatus)

  return (
    <React.Fragment>
      <div className="page-content">
        <Breadcrumb
          title={props.t("Salon")}
          breadcrumbItem={props.t("Edit") + " " + props.t("Salon")}
        />
        <Container fluid={true}>
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Col sm={12}>
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validationType.handleSubmit();
                        return false;
                      }}
                    >
                      <Col sm={12}>
                        <div className="mb-3">
                          <Label className="form-label">
                            {props.t("Name_Eng")}
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="name_en"
                            placeholder={props.t("Name_Eng")}
                            type="text"
                            //readOnly
                            // disabled
                            onChange={validationType.handleChange}
                            onBlur={validationType.handleBlur}
                            value={validationType.values.name_en || ""}
                            invalid={
                              validationType.touched.name_en &&
                              validationType.errors.name_en
                                ? true
                                : false
                            }
                          />
                          {validationType.touched.name_en &&
                          validationType.errors.name_en ? (
                            <FormFeedback type="invalid">
                              {validationType.errors.name_en}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Row>
                        <Col sm={6}>
                          <div className="mb-3">
                            <Label className="form-label">
                              {props.t("Commercial Registration Number")}
                              <span className="text-danger">*</span>
                            </Label>
                            <Input
                              name="registration_number"
                              placeholder={props.t("Registration Number")}
                              readOnly
                              disabled
                              type="text"
                              onChange={validationType.handleChange}
                              onBlur={validationType.handleBlur}
                              value={
                                validationType.values.registration_number || ""
                              }
                              invalid={
                                validationType.touched.registration_number &&
                                validationType.errors.registration_number
                                  ? true
                                  : false
                              }
                            />
                            {validationType.touched.registration_number &&
                            validationType.errors.registration_number ? (
                              <FormFeedback type="invalid">
                                {validationType.errors.registration_number}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Col>

                        <Col sm={6}>
                          <div className="mb-3">
                            <Label className="form-label">
                              {props.t("Address")}
                              <span className="text-danger">*</span>
                            </Label>
                            <Input
                              name="address"
                              placeholder={props.t("Address)")}
                              type="textarea"
                              //readOnly
                              // disabled
                              onChange={validationType.handleChange}
                              onBlur={validationType.handleBlur}
                              value={validationType.values.address || ""}
                              invalid={
                                validationType.touched.address &&
                                validationType.errors.address
                                  ? true
                                  : false
                              }
                            />
                            {validationType.touched.address &&
                            validationType.errors.address ? (
                              <FormFeedback type="invalid">
                                {validationType.errors.address}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                        {mapUrl ? (
                          <Row>
                            <Col lg={12}>
                              <Card>
                                <CardBody>
                                  <h5>{props.t("Salon Location")}</h5>
                                  <iframe
                                    src={mapUrl}
                                    width="100%"
                                    height="400"
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    title={props.t("Salon Location Map")}
                                  ></iframe>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        ) : (
                          <p>{props.t("No location data available")}</p>
                        )}
                      </Row>
                      <Row>
                        {/* <Col sm={6}>
                          <div className="mb-3">
                            <Label className="form-label">
                              {props.t("Geo Location")}<span className="text-danger">*</span>
                            </Label>
                            <Input
                              name="geo_location_link"
                              placeholder={props.t("Geo Location")}
                              type="text"
                              //readOnly
                              // disabled
                              onChange={validationType.handleChange}
                              onBlur={validationType.handleBlur}
                              value={
                                validationType.values.geo_location_link || ""
                              }
                              invalid={
                                validationType.touched.geo_location_link &&
                                  validationType.errors.geo_location_link
                                  ? true
                                  : false
                              }
                            />
                            {validationType.touched.geo_location_link &&
                              validationType.errors.geo_location_link ? (
                              <FormFeedback type="invalid">
                                {validationType.errors.geo_location_link}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Col> */}
                        <Col sm={6}>
                          <div className="mb-3">
                            <Label className="form-label">
                              {props.t("Service at")}
                              <span className="text-danger">*</span>
                            </Label>
                            <Input
                              name="service_at"
                              placeholder={props.t("Service at")}
                              type="text"
                              readOnly
                              disabled
                              onChange={validationType.handleChange}
                              onBlur={validationType.handleBlur}
                              value={validationType.values.service_at || ""}
                              invalid={
                                validationType.touched.service_at &&
                                validationType.errors.service_at
                                  ? true
                                  : false
                              }
                            />
                            {validationType.touched.service_at &&
                            validationType.errors.service_at ? (
                              <FormFeedback type="invalid">
                                {validationType.errors.service_at}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Col>

                        <Col sm={6}>
                          <div className="mb-3">
                            <Label className="form-label">
                              {props.t("Price Range")}
                              <span className="text-danger">*</span>
                            </Label>
                            <Input
                              name="price_range"
                              placeholder={props.t("Price Range")}
                              type="text"
                              readOnly
                              disabled
                              onChange={validationType.handleChange}
                              onBlur={validationType.handleBlur}
                              value={validationType.values.price_range || ""}
                              invalid={
                                validationType.touched.price_range &&
                                validationType.errors.price_range
                                  ? true
                                  : false
                              }
                            />
                            {validationType.touched.price_range &&
                            validationType.errors.price_range ? (
                              <FormFeedback type="invalid">
                                {validationType.errors.price_range}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                      </Row>

                      {/* Images Section - Fixed Layout */}
                      <Row className="mt-4">
                        <Col lg={12}>
                          <h5 className="mb-3">{props.t("Documents & Images")}</h5>
                        </Col>
                        
                        {/* Commercial Registration */}
                        <Col lg={3} md={6} sm={12}>
                          <div className="mb-4 text-center">
                            <Label className="form-label fw-bold mb-2">
                              {props.t("Commercial Registration")}
                              <span className="text-danger">*</span>
                            </Label>
                            <div className="border rounded p-3 bg-light d-flex justify-content-center align-items-center" style={{ minHeight: "160px" }}>
                              {!fileRegUrl ? (
                                <div style={{ fontSize: "14px", color: "#999", fontWeight: "bold" }}>
                                  No Preview Available
                                </div>
                              ) : isRegPDF ? (
                                <i
                                  className="fas fa-file-pdf"
                                  style={{ fontSize: "80px", color: "#d9534f", cursor: "pointer" }}
                                  onClick={toggleimg1}
                                  title={props.t("Click to view PDF")}
                                ></i>
                              ) : (
                                <img
                                  src={fileRegUrl}
                                  alt="Commercial Reg"
                                  className="img-fluid"
                                  style={{ maxHeight: "130px", cursor: "pointer", objectFit: "contain" }}
                                  onClick={toggleimg1}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.style.display = "none";
                                    const fallback = e.target.parentElement.querySelector(".fallback");
                                    if (fallback) fallback.style.display = "block";
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        </Col>

                        {/* VAT Image */}
                        <Col lg={3} md={6} sm={12}>
                          <div className="mb-4 text-center">
                            <Label className="form-label fw-bold mb-2">
                              {props.t("VAT Image")}
                              <span className="text-danger">*</span>
                            </Label>
                            <div className="p-3 d-flex justify-content-center align-items-center" style={{ minHeight: "160px" }}>
                              {!fileVatUrl ? (
                                <div style={{ fontSize: "14px", color: "#999", fontWeight: "bold" }}>
                                  No Preview Available
                                </div>
                              ) : isVATPDF ? (
                                <i
                                  className="fas fa-file-pdf"
                                  style={{ fontSize: "80px", color: "#d9534f", cursor: "pointer" }}
                                  onClick={toggleimg4}
                                  title={props.t("Click to view PDF")}
                                ></i>
                              ) : (
                                <img
                                  src={fileVatUrl}
                                  alt="VAT Reg"
                                  className="img-fluid"
                                  style={{ maxHeight: "130px", cursor: "pointer", objectFit: "contain" }}
                                  onClick={toggleimg4}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.style.display = "none";
                                    const fallback = e.target.parentElement.querySelector(".fallback");
                                    if (fallback) fallback.style.display = "block";
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        </Col>

                        {/* Image */}
                        <Col lg={3} md={6} sm={12}>
                          <div className="mb-4 text-center">
                            <Label className="form-label fw-bold mb-2">
                              {props.t("Image")}
                              <span className="text-danger">*</span>
                            </Label>
                            <div className="p-3 d-flex justify-content-center align-items-center" style={{ minHeight: "160px" }}>
                              {!salon.image ? (
                                <div style={{ fontSize: "14px", color: "#999", fontWeight: "bold" }}>
                                  No image available
                                </div>
                              ) : (
                                <img
                                  src={salon.image}
                                  className="img-fluid"
                                  style={{ maxHeight: "130px", cursor: "pointer", objectFit: "contain" }}
                                  onClick={toggleimg2}
                                  alt="Salon Image"
                                />
                              )}
                            </div>
                          </div>
                        </Col>

                        {/* Logo */}
                        <Col lg={3} md={6} sm={12}>
                          <div className="mb-4 text-center">
                            <Label className="form-label fw-bold mb-2">
                              {props.t("Logo")}
                              <span className="text-danger">*</span>
                            </Label>
                            <div className="p-3 d-flex justify-content-center align-items-center" style={{ minHeight: "160px" }}>
                              {!salon.icon ? (
                                <div style={{ fontSize: "14px", color: "#999", fontWeight: "bold" }}>
                                  No Logo available
                                </div>
                              ) : (
                                <img
                                  src={salon.icon}
                                  className="img-fluid"
                                  style={{ maxHeight: "130px", cursor: "pointer", objectFit: "contain" }}
                                  onClick={toggleimg3}
                                  alt="Salon Icon"
                                />
                              )}
                            </div>
                          </div>
                        </Col>
                      </Row>

                      {/* Modals */}
                      <Modal isOpen={modal} toggle={toggleimg1} size="lg">
                        <ModalHeader toggle={toggleimg1}>{props.t("Commercial Registration Image")}</ModalHeader>
                        <ModalBody className="text-center">
                          {!fileRegUrl ? (
                            <div style={{ padding: "50px", color: "#999" }}>
                              <strong>{props.t("No file available")}</strong>
                            </div>
                          ) : isRegPDF ? (
                            <iframe
                              src={fileRegUrl}
                              width="100%"
                              height="500px"
                              style={{ border: "none" }}
                              title={props.t("PDF Preview")}
                            />
                          ) : (
                            <img
                              src={fileRegUrl}
                              className="img-fluid"
                              alt="Commercial Reg"
                              style={{ maxHeight: "500px", margin: "0 auto" }}
                            />
                          )}
                        </ModalBody>
                      </Modal>

                      <Modal isOpen={modal4} toggle={toggleimg4} size="lg">
                        <ModalHeader toggle={toggleimg4}>{props.t("VAT Image")}</ModalHeader>
                        <ModalBody className="text-center">
                          {!fileVatUrl ? (
                            <div style={{ padding: "50px", color: "#999" }}>
                              <strong>{props.t("No file available")}</strong>
                            </div>
                          ) : isVATPDF ? (
                            <iframe
                              src={fileVatUrl}
                              width="100%"
                              height="500px"
                              style={{ border: "none" }}
                              title={props.t("PDF Preview")}
                            />
                          ) : (
                            <img
                              src={fileVatUrl}
                              className="img-fluid"
                              alt="VAT Image"
                              style={{ maxHeight: "500px", margin: "0 auto" }}
                            />
                          )}
                        </ModalBody>
                      </Modal>

                      <Modal isOpen={modal2} toggle={toggleimg2} size="lg">
                        <ModalHeader toggle={toggleimg2}>{props.t("Salon Image")}</ModalHeader>
                        <ModalBody className="text-center">
                          <img
                            src={salon.image}
                            className="img-fluid"
                            alt="Salon Image"
                            style={{ maxHeight: "500px", margin: "0 auto" }}
                          />
                        </ModalBody>
                      </Modal>

                      <Modal isOpen={modal3} toggle={toggleimg3} size="lg">
                        <ModalHeader toggle={toggleimg3}>{props.t("Salon Logo")}</ModalHeader>
                        <ModalBody className="text-center">
                          <img
                            src={salon.icon}
                            className="img-fluid"
                            alt="Salon Logo"
                            style={{ maxHeight: "500px", margin: "0 auto" }}
                          />
                        </ModalBody>
                      </Modal>

                      <Row>
                        <Col sm={6}>
                          <div className="mb-3">
                            <Label className="form-label">
                              {props.t("Status")}
                              <span className="text-danger">*</span>
                            </Label>
                            <select
                              name="status"
                              className={`form-select ${
                                validationType.touched.status &&
                                validationType.errors.status
                                  ? "is-invalid"
                                  : ""
                              }`}
                              onChange={(e) => {
                                setSalonStatus(e.target.value); // update local state
                                validationType.handleChange(e); // update Formik
                              }}
                              onBlur={validationType.handleBlur}
                              value={validationType.values.status} // bind Formik value
                            >
                              <option value="">
                                {props.t("Select Status")}
                              </option>

                              {/* Conditionally render "Approved" only if no documents */}
                              {documents?.length > 0 ? null : (
                                <option value="Approved">
                                  {props.t("Approved")}
                                </option>
                              )}

                              {salon.status == "Pending" ? (
                                <option value="Pending">
                                  {props.t("Pending")}
                                </option>
                              ) : null}

                              {/* Always include other statuses */}

                              <option value="Amendment_Required">
                                {props.t("Amendment Required")}
                              </option>
                              <option value="Rejected">
                                {props.t("Rejected")}
                              </option>
                            </select>

                            {validationType.touched.status &&
                              validationType.errors.status && (
                                <div className="invalid-feedback">
                                  {validationType.errors.status}
                                </div>
                              )}
                          </div>
                        </Col>
                        {(salonstatus == "Amendment_Required" ||
                          salonstatus == "Rejected") && (
                          <>
                            <Col sm={6}>
                              <div className="mb-3">
                                <Label className="form-label">
                                  {props.t("Reason")}
                                </Label>
                                <Input
                                  name="reason"
                                  placeholder={props.t("Reason")}
                                  type="textarea"
                                  onChange={validationType.handleChange}
                                  onBlur={validationType.handleBlur}
                                  value={validationType.values.reason || ""}
                                  invalid={
                                    validationType.touched.reason &&
                                    validationType.errors.reason
                                      ? true
                                      : false
                                  }
                                />
                                {validationType.touched.reason &&
                                validationType.errors.reason ? (
                                  <FormFeedback type="invalid">
                                    {validationType.errors.reason}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                          </>
                        )}
                      </Row>

                      <div className="d-flex flex-wrap gap-2">
                        <Button type="submit" color="primary">
                          {props.t("Submit")}
                        </Button>{" "}
                        <Button color="secondary" onClick={(e) => formClear()}>
                          {props.t("Clear")}
                        </Button>
                      </div>
                    </Form>
                  </Col>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

SalonsEdit.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(SalonsEdit);